import { Injectable } from "@angular/core";
import { UserData } from "../@core/data/users";
import { User } from "../models/user.model";
import { Observable, of, throwError } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { catchError, map, tap } from "rxjs/operators";
import { NbAuthJWTToken, NbAuthResult, NbAuthService, NbAuthToken } from "@nebular/auth";
import { environment as env } from '../../environments/environment.prod';

@Injectable({
	providedIn: "root",
})
export class UserService extends UserData {
	url = `${env.apiUrl}/users`;
	constructor(private http: HttpClient, private authService: NbAuthService,) {
		super();
	}

	getUsers(): Observable<User[]> {
		return this.http.get<any>(this.url).pipe(
			map((users: User[]) => {
				if (!Array.isArray(users)) {
					throw new Error("Expected an array of users from the backend.");
				}
				return users.map(
					(user) =>
						new User(user.id, user.name, user.role_name, user.email, user.card_nr, env.storage + user.photo, user.restaurant_ids, user.location_ids)
				);
			}),
			catchError((error) => {
				console.error("Error loading users:", error);
				throw error;
			})
		);
	}

	getUserById(id: string): Observable<User> {
		return this.http.get<User>(`${this.url}/${id}`).pipe(map((user) => {
			if(user.photo) {
				user.photo = env.storage + user.photo;
			}
			return user;
		}));
	}

	getCurrentUser(): Observable<User> {
		return this.http.get<User>(`${env.apiUrl}/auth/me`).pipe(map((user) => {
			if(user.photo) {
				user.photo = env.storage + user.photo;
			}
			console.log(user);
			
			return user;
		}));
	}

	updateUser(user: {
		id?: string,
		name?: string,
		role_name?: string,
		email?: string,
		card_nr?: string,
		password?: string,
		photo_file?: File,
		restaurant_ids?: string[],
		location_ids?: string[]
	}): Observable<User> {
		const formData = new FormData();
		formData.append("name", user.name ?? null);
		if(user.role_name) {
			formData.append("role_name", user.role_name);
		}
		formData.append("email", user.email);
		if(user.card_nr) {
			formData.append("card_nr", user.card_nr);
		}
		if(user.password) {
			formData.append("password", user.password);
		}
		formData.append("restaurant_ids", JSON.stringify(user.restaurant_ids));
		formData.append("location_ids", JSON.stringify(user.location_ids));

		if (user.photo_file) {
			formData.append("photo", user.photo_file, user.photo_file.name);
		}

		formData.append('_method', 'PUT');
		
		return this.http.post<User>(`${this.url}/${user.id}`, formData).pipe(map((user) => {
			if(user.photo) {
				user.photo = env.storage + user.photo;
			}
			return user;
		}));
		}

	addUser(user: {
		id?: string,
		name?: string,
		role_name?: string,
		email?: string,
		card_nr?: string;
		password?: string
		photo_file?: File
		restaurant_ids?: string[],
		location_ids?: string[]
		}): Observable<User> {
			const formData = new FormData();
			formData.append("name", user.name ?? null);
			if(user.role_name){
				formData.append("role_name", user.role_name);
			}
			formData.append("email", user.email ?? null);
			if(user.card_nr) {
				formData.append("card_nr", user.card_nr);
			}
			formData.append("password", user.password ?? null);
			formData.append("restaurant_ids", JSON.stringify(user.restaurant_ids));
			formData.append("location_ids", JSON.stringify(user.location_ids));
			if (user.photo_file) {
				formData.append("photo", user.photo_file, user.photo_file.name);
			}
			
			return this.http.post<User>(this.url, formData).pipe(map((user) => {
				if(user.photo) {
					user.photo = env.storage + user.photo;
				}
				return user;
			}));
		}

		deleteUser(id: string): Observable<User> {
			return this.http.delete<User>(`${this.url}/${id}`).pipe(map((user) => {
				if(user.photo) {
					user.photo = env.storage + user.photo;
				}
				return user;
			}));
		}
}
